import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'swb-pages',
  templateUrl: './pages.component.html'
})
export class PagesComponent implements OnInit {
  public query: string;

  @Output() filterEvent = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  public filter(query: string): void {
    this.query = query;
  }
}
